import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {CONTENT_SUBMISSION_ROUTES} from '@/routes/content-submissions/contentSubmissionRouteDefinitions';
import OffPlatformLayout from '@/views/off-platform-review/OffPlatformLayout';
import OffPlatformContentSubmissionView from '@/views/off-platform-review/content-submissions/OffPlatformContentSubmissionView';
import OffPlatformContentSubmissions from '@/views/off-platform-review/content-submissions/OffPlatformContentSubmissions';
import OffPlatformMixedMediaView from '@/views/off-platform-review/content-submissions/OffPlatformMixedMediaView';

function OffPlatformReviewRoutes() {
  return (
    <Routes>
      <Route path=":campaignId" element={<OffPlatformLayout />}>
        <Route
          path={CONTENT_SUBMISSION_ROUTES.contentSubmissionsList}
          element={<OffPlatformContentSubmissions />}
        />
        <Route
          path={CONTENT_SUBMISSION_ROUTES.parentContentSubmission}
          element={<OffPlatformMixedMediaView />}
        />
        <Route
          path={CONTENT_SUBMISSION_ROUTES.mixedMediaContentSubmission}
          element={<OffPlatformContentSubmissionView />}
        />
        <Route
          path={CONTENT_SUBMISSION_ROUTES.contentSubmission}
          element={<OffPlatformContentSubmissionView />}
        />
      </Route>
    </Routes>
  );
}

export default OffPlatformReviewRoutes;
